import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useMemo } from 'react';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import EcoImg from 'eco-design/base/eco-img';

export default function Comp() {
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct.EarlyBirdOffer');

    const list = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755249891069/1.png',
            title: t('item1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755249890550/2.png',
            title: t('item2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1755249890907/3.png',
            title: t('item3'),
        },
    ];
    return (
        <div className={styles.comp} id="EarlyBirdOffer">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className="container">
                {list.map((i, idx) => (
                    <div className="item" key={idx}>
                        <EcoImg pc={i.pc} />
                        <div className="title">{i.title}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
